import {BoxProps, HStack, Stack, Td, Text, Tr} from "@chakra-ui/react";
import * as React from "react";
import {ReactNode} from "react";

export const AddTableRow = ({name, children}: { name: string, children: ReactNode }) => {
    return <Tr>
        <Td display={"flex"} h={"100%"} verticalAlign={"top"} justifyContent={"start"}>
            <Stack>
                <Text fontWeight={"bold"} h={"100%"} verticalAlign={"start"}
                      textAlign={"start"}>{name}</Text>
            </Stack>
        </Td>
        <Td wordBreak={"break-word"}>
            {children}
        </Td>
    </Tr>
}

export const KeyValueRow = ({name, children, props}: { name: string, children: ReactNode, props?: BoxProps }) => {
    return <HStack minH={"36px"} alignItems={"flex-start"} {...props}>
        <Text fontWeight={"bold"} minW={"84px"} verticalAlign={"start"}
              textAlign={"start"}>{name}</Text>
        <Text>{children}</Text>
    </HStack>
}
